import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { CustomerService } from "../../../services/customer.service";

import { Customer } from "../../../models/customer.model";
import { History } from "../../../models/history.model";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogCustomerComponent } from "../../dialog-customer/dialog-customer.component";
import { DialogHistoryComponent } from "../../dialog-history/dialog-history.component";
import { UserService } from "../../../@core/services/user.service";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Person } from "../../../models/person.model";
import { Catalog } from "../../../models/product.model";
import { User } from "../../../@core/data/users";
import { ShopService } from "../../../services/shop.service";
import { DialogDeptCustomerArchiveComponent } from "../../dialogs/dialog-dept-customer-archive/dialog-dept-customer-archive.component";

@Component({
  selector: "ngx-view-customer",
  styleUrls: ["./view-customer.component.scss"],
  templateUrl: "./view-customer.component.html",
})
export class ViewCustomerComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = ""; //home / customer/dept
  @Input() customer: Customer;
  @Input() isMore? = false;
  @Input() users?: Person[];
  @Input() productCategories?: Catalog[];

  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "main";
  uid = "";
  isMobile = false;
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  user?: User;

  constructor(
    public userService: UserService,
    public shopService: ShopService,
    private customerService: CustomerService,
    private dialogService: NbDialogService,
    private router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService,
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.uid = user.uid;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          console.log(
            "🚀 ~ ViewCustomerComponent ~ constructor ~  this.customerZ:",
            this.customer,
          );
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.customer.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$),
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  archiveData() {
    this.dialogService
      .open(DialogDeptCustomerArchiveComponent, {
        context: {
          shop: this.shopService.shop,
          uid: this.uid,
          user: this.user,
          customerCurrent: this.customer,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Customer) => {
        if (value) {
          console.log(
            "🚀 ~ ViewCustomerComponent ~ .onClose.subscribe ~ value:",
            value,
          );
        }
      });
  }

  selectDetail() {
    this.onSelect.emit(this.customer);
    this.loadContent(true);
  }

  loadContent(value?: boolean) {
    this.isMore = value;
  }

  loadButtonAction(item) {
    if (this.user.moderator) {
      this.menuItems = [
        { title: "Sửa", icon: "edit-2-outline", data: item },
        { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/customer/${this.customer.id}`,
        },
      ];
    } else {
      this.menuItems = [
        { title: "Sửa", icon: "edit-2-outline", data: item },
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/customer/${this.customer.id}`,
        },
      ];
    }
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.customerService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: Customer) {
    let lecBk = new Customer();
    lecBk = clone(item);
    this.dialogService
      .open(DialogCustomerComponent, {
        context: {
          header: "Cập nhật khách hàng",
          mode: "edit",
          shopId: this.shopId,
          user: this.user,
          customer: lecBk,
          users: this.users,
          productCategories: this.productCategories,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.customer = value;
          this.onEdit.emit(value);
        }
      });
  }

  createHistory(item: Customer) {
    let lecNew = new History();
    lecNew.customerId = item.id;
    lecNew.fullName = item.fullName;
    lecNew.dobYear = item.dobYear;
    lecNew.issueDate = new Date();

    this.dialogService
      .open(DialogHistoryComponent, {
        context: {
          header: "Tạo trạng thái",
          mode: "new",
          history: lecNew,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
        }
      });
  }

  createReceipt(item: Customer) {
    // let lecNew = new History();
    // lecNew.customerId = item.id;
    // lecNew.fullName = item.fullName;
    // lecNew.dobYear = item.dobYear;
    // lecNew.issueDate = new Date();
    // this.dialogService
    //   .open(DialogHistoryComponent, {
    //     context: {
    //       header: "Tạo trạng thái",
    //       mode: "new",
    //       history: lecNew,
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //     }
    //   });
  }

  viewHistory(item) {
    this.router.navigateByUrl("/customer/" + item.id);
  }
}
